/// <reference path="checkbox.ts" />

/**
 * <dl>
 * <dt>属性</dt>
 * <dd>uncheck: 設定されている場合はクリックやキー入力でチェックを外すことが可能になります</dd>
 * </dl>
 * その他の属性はKoyoriCheckboxに依存します。
 */
class KoyoriRadio extends KoyoriCheckbox {

	static get observedAttributes() {
		return ['label', 'message'].concat(this.inputAttributes);
	}

	static get inputAttributes() {
		return ['value', 'name', 'disabled', 'autocomplete', 'list', 'maxlength', 'pattern', 'placeholder', 'readonly', 'inputmode', 'checked'];
	}

	constructor() {
		super();

		let wrapper = this.inputElement.parentElement;
		wrapper.addEventListener('mouseup', (event) => {
			if (event.button == 0 && this.getAttribute('uncheck') != null && (<HTMLInputElement>this.inputElement).checked) {
				this.uncheckAsync();
			}
		});
		wrapper.addEventListener('keyup', (event) => {
			if (event.keyCode == 32 && this.getAttribute('uncheck') != null && (<HTMLInputElement>this.inputElement).checked) {
				this.uncheckAsync();
			}
		});
	}

	/**
	 * @return inputタグのtype属性の値
	 */
	protected getInputType(): string {
		return 'radio';
	}

	/**
	 * @return 変更イベントを取得する属性のリスト
	 */
	protected getObservedAttributes(): string[] {
		return KoyoriRadio.observedAttributes;
	}

	/**
	 * @return inputタグに設定する属性のリスト
	 */
	protected getInputAttributes(): string[] {
		return KoyoriRadio.inputAttributes;
	}

	protected uncheckAsync(): void {
		console.log('test');
		setTimeout(() => {
			this.checked = false;
		}, 0);
	}

}
window.customElements.define('koy-radio', KoyoriRadio);
